// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__17S3l","image":"logo_image__WyQ4a"};